import { authHttp } from '../http'
import * as routes from '../../routes/system.routes'
import { errorHandler } from '../../../util/error.service'

export async function getCompanyCnpjs(companyId) {
  try {
    const { data } = await authHttp().get(routes.urlSystemCompanyCnpjs(companyId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCompanyCnpj(companyId, cnpj) {
  try {
    const { data } = await authHttp().post(routes.urlSystemPostCompanyCnpj(companyId), { cnpj })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteCompanyCnpj(id) {
  try {
    const { data } = await authHttp().delete(routes.urlSystemDeleteCompanyCnpj(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
